/**
 * 判断数据类型
 * ex:  let arr = [1,2,3]
 *      isArray(arr) => true
 *      isString(arr) => false
 */
function isType(type) {
    return function (params) {
      return Object.prototype.toString.call(params) == `[object ${type}]`
    }
}
  
const isArray = isType('Array');
const isObject = isType('Object');
const isString = isType('String');
const isNumber = isType('Number');
const isBoolean = isType('Boolean');

/**
 * 校验手机号码是否合法
 * 传入string类型
 * return  true或者false
 */
function checkPhone(phonenum) {
    // var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
    //var reg = /^1\d{10}$/
    var reg=/^1[3456789]\d{9}$/;
    var tag = true
    if (phonenum === '') tag = false
    if (!phonenum || phonenum.length !== 11) {
      tag = false
    } else if (!reg.test(phonenum)) {
      tag = false
    }
    return tag
}
/**
 * 验证身份证号方法（满足18位）
 * return  true或者false
 */
function checkIdentity(idCard) {
    // var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;//一代身份不可用
    var reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!reg.test(idCard)) return false;
    // 校验出生日期是否合法
    let birthday = idCard.substr(6, 4) + '-' + idCard.substr(10, 2) + '-' + idCard.substr(12, 2);
    if (!isDate(birthday)) return false;
    return true;
}
/**
 * 返回生日
 * 传入idCard（身份证） 
 */
function reBirthday(idCard) {
  let birthday = idCard.substr(6, 4) + '-' + idCard.substr(10, 2) + '-' + idCard.substr(12, 2);
  return birthday;
}
/**
 * 是否合法日期
 * @param date 日期 yyyy-mm-dd
 * @return true/false
 */
function isDate(date) {
  var a = date.split('-');
  var d = new Date(date.replace(/-/g, "/"));
  a[1] = Number(a[1]);
  a[2] = Number(a[2]);
  if (a[0] == d.getFullYear() && a[1] == d.getMonth() + 1 && a[2] == d.getDate()) return true;
  return false;
}
/**
 * 验证身份证号是否合法（符合公安部身份证号规则）
 * return  true或者false
 */
function checkIdentityLegal(idCard) {
  if (!checkIdentity(idCard)) return false;
  //∑(ai×Wi)(mod 11)
  //加权因子
  var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  //校验位
  var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
  var sum = 0, ai = 0, wi = 0;
  for (var i = 0; i < 17; i++) {
    ai = idCard[i];
    wi = factor[i];
    sum += ai * wi;
  }
  var last = parity[sum % 11];
  if (parity[sum % 11] != idCard[17].toLocaleUpperCase()) {
    return false;
  }
  return true;
}
/**
 * formatDate日期格式化
 * return xxxx-xx-xx 
 */
function formatDate(date) {
  if (!date) return false;
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  var ds = date.getDate()
  return `${y}-${m < 10 ? '0' + m : m}-${ds < 10 ? '0' + ds : ds}`
}

/**
 * 检测是否在微信浏览器下
 */
const isWechat = ()=>{
  var ua = navigator.userAgent.toLowerCase();
  // console.log(ua)
  if(ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
  } else {
      return false;
  }
};

//调用微信JS api 支付
const jsApiCall = (jsApiParameters, return_url,cancel_url)=>{
  return new Promise((resolve,reject) => {
    WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        jsApiParameters,
        function(res) {
            WeixinJSBridge.log(res.err_msg);
            if(res.err_msg=='get_brand_wcpay_request:cancel'){
              window.location.href = cancel_url?cancel_url:return_url;
            }else if(res.err_msg=='get_brand_wcpay_request:ok'){
                setTimeout(()=>{
                  // window.location.href = return_url;
                  resolve(true)
                  sessionStorage.clear();
                },1000);
            }
        }
    );
  })
};

const wechatPayCallpay = (jsApiParameters, return_url, cancel_url) =>{
  // console.log('WXP:', jsApiParameters, WeixinJSBridge)
  return new Promise((resolve,reject) => {
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', jsApiCall);
            document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
        }
    } else {
      resolve(jsApiCall(jsApiParameters, return_url, cancel_url));
    }
  })
};

/**
 * 随机处理
 * Array.sort(randomsort)
 */
const randomsort = (a, b) => {
  return Math.random()>.5 ? -1 : 1;
}

/**
   * 判断是否可以再次获取短信
   * @param {开始时间} stime ;
   * @param {结束时间} etime ;
   */
const calculateDiffTime = (stime, etime) => {
  var startTime, endTime
  if (stime < etime) {
    startTime = stime
    endTime = etime
  } else {
    startTime = etime
    endTime = stime
  }
  var timeDiff = endTime - startTime
  // var hour = Math.floor(timeDiff / 3600)
  // timeDiff = timeDiff % 3600
  // var minute = Math.floor(timeDiff / 60)
  // timeDiff = timeDiff % 60
  var second = Math.floor(timeDiff / 1000)
  // return [hour, minute, second]
  return second
}

//调用微信JS分享
const jsApiShare = (jsApiParameters)=>{
  WeixinJSBridge.invoke('sendAppMessage',{  
    "appid": jsApiParameters.appid,
    "img_url": jsApiParameters.img,  
    "img_width": "200",  
    "img_height": "200",  
    "link": jsApiParameters.url,  
    "desc": jsApiParameters.desc,  
    "title": jsApiParameters.tit,  
  });
  WeixinJSBridge.invoke('shareTimeline',{  
    "img_url": jsApiParameters.img,  
    "img_width": "200",  
    "img_height": "200",  
    "link": jsApiParameters.url,  
    "desc": jsApiParameters.desc,  
    "title": jsApiParameters.tit
  }); 
};
const wechatShare = (jsApiParameters) =>{
  if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', jsApiShare, false);
      } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', jsApiShare);
          document.attachEvent('onWeixinJSBridgeReady', jsApiShare);
      }
  } else {
    jsApiShare(jsApiParameters);
  }
};
const wechatShareConfig = (params)=>{
  wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: params.appId, // 必填，公众号的唯一标识
      timestamp: params.timestamp, // 必填，生成签名的时间戳
      nonceStr: params.nonceStr, // 必填，生成签名的随机串
      signature: params.signature, // 必填，签名，见附录1
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });

  wx.ready(function () {
      if (!isWechat()) {
        wx.hideOptionMenu();
      } else {
        wx.showOptionMenu();
      }

      wx.updateTimelineShareData({
          imgUrl: params.imgUrl,
          link: params.link,
          title: params.title,
          desc: params.desc,
          success: function () {
          },
          cancel: function () {
          }
      });
      /*分享给朋友*/
      wx.updateAppMessageShareData({
          imgUrl: params.imgUrl,
          link: params.link,
          title: params.title,
          desc: params.desc,
          success: function () {
          },
          cancel: function () {
          }
      });

  });
  wx.error(function (res) {
    console.log(JSON.stringify(res));
  });
};

// 清除数据localStorage
const toAuth = () => {
  localStorage.clear()
  window.location.href = window.location.href;
};

/**
   *  字符串长度
   */
const getSLen = (str) => {
  if (str == null) return 0
  if (typeof str !== 'string') {
    str += ''
  }
  return str.replace(/[^\x00-\xff]/g, '01').length
};

/**
 * 检查sessionData
 */
const checkSData = (data, key) => {
  let ch = JSON.parse(sessionStorage.getItem('_sessionData')) || {};
  if (ch && ch[key] === JSON.stringify(data)) {
    return true;
  } else {
    ch[key] = JSON.stringify(data);
    sessionStorage.setItem('_sessionData', JSON.stringify(ch));
    return false;
  }
}

/**
  *  深度复制对象
  */
const deepClone = (obj) => {
  var o, i, j
  if (typeof (obj) !== 'object' || obj == null) return obj
  if (obj instanceof (Array)) {
    o = []
    i = 0; j = obj.length
    for (; i < j; i++) {
      if (typeof (obj[i]) === 'object' && obj[i] != null) {
        o[i] = deepClone(obj[i])
      } else {
        o[i] = obj[i]
      }
    }
  } else {
    o = {}
    for (i in obj) {
      if (typeof (obj[i]) === 'object' && obj[i] != null) {
        o[i] = deepClone(obj[i])
      } else {
        o[i] = obj[i]
      }
    }
  }
  return o
}

/**
  *  获取URL参数
  *  url ：传入链接
  *  id ： 查询Key
  */
const GetParam = (url, id) => {
  url = url+ "";
  regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
  reg = eval(regstr);
  result = url.match(reg);

  if (result && result[2]) {
    return result[2];
  }
}

export default {
    checkPhone, //校验手机号
    checkIdentity, //校验身份证号
    checkIdentityLegal, //校验身份证是否符合公安部规则
    isArray,                  //判断是否是数组
    isObject,                 //判断是否是对象
    isString,                 //判断是否是对象
    isNumber,                 //判断是否是数字类型
    isBoolean,                //判断是否是布尔值
    formatDate,                //返回格式yyyy-mm-dd
    wechatPayCallpay,         //微信支付
    isWechat,                 //微信浏览器检测
    randomsort,                //打乱数组
    calculateDiffTime,        //时间差
    wechatShare,              //微信分享
    toAuth,                   //清空操作
    getSLen,                   //获取字符串长度
    wechatShareConfig,          //分享
    checkSData,                  //检查sessionData
    reBirthday,                  //返回生日
    deepClone,                   //深拷贝
    GetParam                    //获取URL参数
}